import '@babel/polyfill';
import routes from './routes';
import { render } from 'react-dom';

import '../static/assets/css/index.scss';

render(routes, window.document.getElementById('identity-ui-client-react-root'));
